import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepOneLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepOneLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.memoryStepOneLevels.data.memoryStepOneLevelsRandom,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
